import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

/**
 * This directive check if input contain only alphacharacters in lower or uppercase
 * @example
 *   ```html
 *   <input onlyAlphabetic>
 *   ```
 */
@Directive({
  selector: '[onlyAlphabetic]',
  standalone: true,
  providers: [],
})
export class OnlyAlphabeticDirective {
  constructor(
    private readonly element: ElementRef,
    private readonly ngControl: NgControl,
  ) {}

  @HostListener('input', ['$event'])
  onInputChange($event: any) {
    const initialValue = this.element.nativeElement.value;
    const newValue = initialValue.replaceAll(/[^a-zA-Z]*/g, '');

    if (initialValue !== newValue) {
      $event.stopPropagation();
      this.ngControl.control?.setValue(newValue);
    }
  }
}
